/* Zoleado cart cross-sell — self-contained. Fetches Shopify's contextual "related"
   recommendations for the first cart item and renders ADD rows inside the cart
   drawer. Single-variant products add in one tap via Focal's native
   <form is="product-form">; SIZED products open Focal's own quick-buy popup
   (drawer on desktop, bottom sheet on mobile) with image/price/size/qty — same
   component Focal uses on collection cards. Drawer refreshes and the free-hat /
   free-shipping bars update automatically. No app. */
(function () {
  if (customElements.get('zoleado-crosssell')) return;

  var fmt = function (cents) { return '$' + (Number(cents) / 100).toFixed(2); };
  var sized = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
  /* The drawer's innerHTML is swapped on every add (re-creating this element), but this
     module scope survives — cache recommendations per product so each add doesn't refetch. */
  var recCache = {};

  class ZoleadoCrossSell extends HTMLElement {
    connectedCallback() { if (this._built) return; this._built = true; this.build(); }
    async build() {
      var pid = this.getAttribute('product-id');
      if (!pid) { this.innerHTML = ''; return; }
      try {
        /* The mini-cart section renders the cart's product ids into the in-cart attribute,
           so re-renders filter WITHOUT a /cart.js roundtrip (rows appear instantly from the
           recommendation cache instead of popping in a beat later). Fallback keeps the old
           fetch for safety if the attribute is ever missing. */
        var inCart = {};
        var inCartAttr = this.getAttribute('in-cart');
        if (inCartAttr) {
          inCartAttr.split(',').forEach(function (id) { if (id) inCart[id.trim()] = true; });
        } else {
          var cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
          cart.items.forEach(function (i) { inCart[i.product_id] = true; });
        }

        recCache[pid] = recCache[pid] || fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&intent=related&limit=10').then(function (r) { return r.json(); });
        var data = await recCache[pid];
        var products = (data.products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
        if (!products.length) { this.innerHTML = ''; return; }

        var heading = esc(this.getAttribute('heading') || 'You might also like');
        var rows = products.map(function (p) {
          var variants = p.variants || [];
          var firstAvail = variants.filter(function (x) { return x.available; })[0];
          var pv = firstAvail || variants[0];
          var img = sized(p.featured_image || (p.images && p.images[0]) || '', 240); /* 240 so the 80px thumbs stay sharp at 2-3x DPR */
          var price = '';
          if (pv) {
            price = (pv.compare_at_price && Number(pv.compare_at_price) > Number(pv.price))
              ? '<span class="zcs__price-sale">' + fmt(pv.price) + '</span> <span class="zcs__price-was">' + fmt(pv.compare_at_price) + '</span>'
              : fmt(pv.price);
          }
          var control;
          if (!firstAvail) {
            control = '<span class="zcs__add zcs__add--out">Sold out</span>';
          } else if (variants.length > 1) {
            /* Sized products: Focal's own quick-buy popup (Hondo-style) instead of a dropdown.
               ToggleButton opens the element matching aria-controls; QuickBuyDrawer/Popover
               lazy-fetch the product URL and lift out its #quick-buy-content template —
               image, price, size swatches, qty, add-to-cart, all wired to the drawer refresh. */
            var qbId = 'zcs-qb-' + p.id;
            control =
                '<div class="zcs__form">'
              +   '<button type="button" is="toggle-button" loader aria-controls="' + qbId + '-drawer" aria-expanded="false" class="zcs__add hidden-phone">Add</button>'
              +   '<button type="button" is="toggle-button" aria-controls="' + qbId + '-popover" aria-expanded="false" class="zcs__add hidden-tablet-and-up">Add</button>'
              + '</div>'
              + '<quick-buy-popover id="' + qbId + '-popover" href="' + p.url + '" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>'
              + '<quick-buy-drawer id="' + qbId + '-drawer" href="' + p.url + '" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>';
          } else {
            control = '<form is="product-form" action="/cart/add" method="post" class="zcs__form"><input type="hidden" name="id" value="' + firstAvail.id + '"><button type="submit" name="add" is="loader-button" data-product-add-to-cart-button class="zcs__add">Add</button></form>';
          }
          return '<div class="zcs__row">'
            + '<a href="' + p.url + '" class="zcs__thumb" tabindex="-1" aria-hidden="true">' + (img ? '<img class="zcs__img" src="' + img + '" alt="" loading="lazy">' : '') + '</a>'
            + '<div class="zcs__info"><a href="' + p.url + '" class="zcs__title">' + esc(p.title) + '</a><span class="zcs__price">' + price + '</span></div>'
            + control
            + '</div>';
        }).join('');

        this.innerHTML = '<div class="zcs"><p class="zcs__heading">' + heading + '</p><div class="zcs__list">' + rows + '</div></div>';

        /* Quick-buy cleanup wiring. Focal auto-closes only the POPOVER on variant:added;
           the desktop drawer would otherwise sit open until the cart re-render wipes it
           mid-animation. And DrawerContent removes documentElement 'lock-all' on ANY
           drawer close — restore it, because the cart drawer underneath is still open.
           No stale-reference risk: every cart re-render re-creates this element and
           re-runs build(), rebuilding rows + listeners from scratch. */
        this.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(function (qb) {
          qb.addEventListener('variant:added', function () { qb.open = false; });
          qb.addEventListener('openable-element:close', function () {
            if (document.querySelector('cart-drawer[open]')) {
              document.documentElement.classList.add('lock-all');
            }
          });
        });
      } catch (e) { this.innerHTML = ''; }
    }
  }
  customElements.define('zoleado-crosssell', ZoleadoCrossSell);
})();
